import { Component } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'notchmark-main',
    standalone: true,
    imports: [CommonModule, HeaderComponent, FooterComponent, RouterOutlet],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent {
}
